// import React, { useState } from "react";

// const Checkbox = ({ label, value, onChange, defaultChecked }) => {
//   const [isChecked, setIsChecked] = useState(defaultChecked || false);

//   const handleChange = (event) => {
//     setIsChecked(event.target.checked);
//     if (onChange) {
//       onChange(event.target.checked); // Call provided onChange handler
//     }
//   };

//   return (
//     <div className="checkbox-container">
//       <input
//         type="checkbox"
//         id={value}
//         value={value}
//         checked={isChecked}
//         onChange={handleChange}
//       />

//       {label && (
//         <label className="ml-2" htmlFor={value}>
//           {label}
//         </label>
//       )}
//     </div>
//   );
// };

// export default Checkbox;

import React, { useState } from "react";
import styled, { keyframes } from "styled-components";

const Input = styled.input`
  height: 0;
  width: 0;
  opacity: 0;
  z-index: -1;
`;

const Label = styled.label`
  position: relative;
  display: inline-block;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  // margin: 0.6em 1em;
`;

const rotate = keyframes`
 from {
    opacity: 0;
    transform: rotate(0deg);
  }
  to {
    opacity: 1;
    transform: rotate(45deg);
  }
`;

const Indicator = styled.div`
  width: 1.2em;
  height: 1.2em;
  // background: #fff;
  background: white;
  position: absolute;
  // top: 0em;
  top: 0.2em;
  left: -1.6em;
  border: 1px solid #b7bdca;
  border-radius: 6px;

  ${Input}:not(:disabled):checked + & {
    background: #3451d7;
    border: 1px solid #3451d7;
  }

  ${Label}:hover & {
    // background: #ccc;
  }

  &::after {
    content: "";
    position: absolute;
    display: none;
  }

  ${Input}:checked + &::after {
    display: block;
    top: 0.15em;
    left: 0.4em;
    width: 30%;
    height: 60%;
    // border: solid #263238;
    border: solid white;
    border-width: 0 0.2em 0.2em 0;
    animation-name: ${rotate};
    animation-duration: 0.3s;
    animation-fill-mode: forwards;
  }

  &::disabled {
    cursor: not-allowed;
  }
`;

export default function Checkbox({
  value,
  checked,
  onChange,
  name,
  id,
  label,
  disabled,
}) {
  return (
    <Label htmlFor={id} disabled={disabled}>
      {label}
      <Input
        id={id}
        type="checkbox"
        name={name}
        value={value}
        disabled={disabled}
        checked={checked}
        onChange={onChange}
      />
      <Indicator />
    </Label>
  );
}
